<template>
    <div class="disease-info">
        <div class="disease-item">
            <div class="disease-header">
                <div class="header-title">病种分类</div>
                <div class="tag-operate" @click="goToEdit(2)">
                    <div class="icon-title">修改</div>
                    <div class="icon-box"></div>
                </div>
            </div>
            <BaseAddTag :type="2" :tag-list="tagListData[1]" />
        </div>
        <div class="disease-item">
            <div class="disease-header">
                <div class="header-title">西医诊断</div>
                <div class="tag-operate" @click="goToEdit(3)">
                    <div class="icon-title">修改</div>
                    <div class="icon-box"></div>
                </div>
            </div>
            <BaseAddTag :type="3" :tag-list="tagListData[2]" />
        </div>
        <div class="disease-item">
            <div class="disease-header">
                <div class="header-title">藏医诊断</div>
                <div class="tag-operate" @click="goToEdit(4)">
                    <div class="icon-title">修改</div>
                    <div class="icon-box"></div>
                </div>
            </div>
            <BaseAddTag :type="4" :tag-list="tagListData[3]" />
        </div>
        <div class="disease-item">
            <div class="disease-header">
                <div class="header-title">病情简述</div>
                <div class="tag-operate" @click="goToEdit(5)">
                    <div class="icon-title">修改</div>
                    <div class="icon-box"></div>
                </div>
            </div>
            <div class="description-box">综诉：{{ userInfo.illnessSyntheticDes || '-' }}</div>
            <div class="description-box" v-for="(item, index) in patientInfo.askInfoList" :key="index">
                {{`第${formatNum(index +
                1)}疗程：${item.askIllness || ''}`}}</div>
        </div>
        <div class="disease-item">
            <div class="disease-header">
                <div class="header-title">主诉症状</div>
                <div class="tag-operate" @click="goToEdit(6)">
                    <div class="icon-title">修改</div>
                    <div class="icon-box"></div>
                </div>
            </div>
            <BaseAddTag :type="5" :tag-list="tagListData[4]" />
        </div>
    </div>
</template>
<script>
import { formatNum } from '@/utils/baseFormat'
import BaseAddTag from './baseAddTag.vue';
export default {
    name: 'DiseaseInfo',
    props: {
        userInfo: {
            type: Object,
            default: () => { }
        },
        patientInfo: {
            type: Object,
            default: () => { }
        }
    },
    components: {
        BaseAddTag
    },
    data() {
        return {
            formatNum: formatNum
        }
    },
    computed: {
        tagListData() {
            const tagList = {
                1: [],
                2: [],
                3: [],
                4: []
            };
            (this.patientInfo.diseaseList || []).forEach(item => {
                tagList[item.type].push(item)
            })
            return tagList
        }
    },
    created() { },
    mounted() { },
    methods: {
        goToEdit(type) {
            this.$router.push({
                name: 'EditMoreEffective',
                query: {
                    type,
                    id: this.$route.query.id
                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.disease-info {
    .disease-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;

        .header-title {
            font-size: 14px;
            color: #333333;
        }
    }

    .description-box {
        font-size: 14px;
        color: #333333;
        line-height: 16px;
        white-space: pre-wrap;
        word-break: break-all;
        padding: 10px 15px;
        background: #FFFFFF;
        width: calc(100vw - 50px);
        margin-left: -15px;

        &:nth-child(odd) {
            background: #eff3fb;
        }
    }
}
</style>
